import { __CONTAINER_INTERNALS_DO_NOT_USE__ } from '@inno-tools/container-bridge'
import { useWindowManager } from 'modules/desktop/pages/MainPage/components/WindowManager/hooks/useWindowManager'
import { useNavigate } from 'react-router-dom'
import { useCommonStore } from 'shared/stores/commonStore'

/**
 * Handles OPEN_WINDOW from apps and widgets on every page, not only on the desktop.
 * On a detached app page windows aren't rendered, so the target opens as a page instead.
 */
export const useOpenWindowEventListener = () => {
  const { openAppWindow } = useWindowManager()
  const navigate = useNavigate()
  const isDetached = useCommonStore(state => state.isDetached)

  __CONTAINER_INTERNALS_DO_NOT_USE__.useContainerEventListener__INTERNAL__({
    OPEN_WINDOW: data => {
      if (isDetached) {
        navigate(data.url)
        return
      }
      openAppWindow(data.windowId, data.url)
    }
  })
}
